import React from "react";

import { Spacer } from "../../Grid/Spacer";

import styles from "./BulkActionBar.scss";

interface BulkActionBarProps {
  isOpen?: boolean;
  children?: React.ReactNode;
}

export function BulkActionBar({
  isOpen = false,
  children,
}: BulkActionBarProps): React.ReactElement {
  return (
    <div className={styles["bulk-actions-bar"]}>
      <Spacer orientation="vertical" />
      {Boolean(isOpen) && (
        <div data-testid="bulk-action-bar" className={styles["bulk-actions"]}>
          {children}
        </div>
      )}
    </div>
  );
}
